import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// @material-ui/core components
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  LinearProgress,
  TextField,
  IconButton,
  Icon,
} from "@material-ui/core";
// @material-ui/styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../../assets/jss/layouts/appStyle";
// core components
import { SchoolsRepository } from "./SchoolsRepository";
import { LOCALE } from "../../../properties/Locale";
import EntityMetadata from "../../../common/components/EntityMetadata";
import CardBody from "../../../common/components/Card/CardBody";
import Card from "../../../common/components/Card/Card.js";
import CardHeader from "../../../common/components/Card/CardHeader.js";

const useStyles = makeStyles(styles);

export default function SchoolDetailsComponent(props) {
  const classes = useStyles();
  const [schoolId] = useState(props.match.params.schoolId);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    const loadSchool = (id) => {
      setLoading(true);
      SchoolsRepository.fetchSchool(id).then((res) => {
        setData(res.data);
        setLoading(false);
      });
    };

    loadSchool(schoolId);
  }, [schoolId]);

  return (
    <div>
      <Card>
        <Dialog
          open={true}
          maxWidth="md"
          fullWidth={true}
          onClose={() => {}}
          aria-labelledby="form-dialog-title"
          PaperProps={{
            style: {
              overflowY: "unset",
            },
          }}
        >
          <CardHeader color="theme">
            <h4 className={classes.cardTitleWhite}>
              {`${LOCALE.schools_details}${
                data?.name ? ": " + data?.name : ""
              }`}
              <Link
                to={`/app/configuration/schools/`}
                style={{ textDecoration: "none" }}
              >
                <IconButton
                  style={{ float: "right", color: "white" }}
                  aria-label="close"
                >
                  <Icon>close</Icon>
                </IconButton>
              </Link>
            </h4>
          </CardHeader>
          <CardBody>
            {loading ? <LinearProgress /> : ""}
            <div>
              <DialogContent>
                <TextField
                  id="name"
                  label={LOCALE.name}
                  fullWidth={true}
                  value={data?.name ? data?.name : ""}
                  margin="normal"
                  variant="outlined"
                  InputProps={{
                    readOnly: true,
                  }}
                  size="small"
                />
                <TextField
                  id="municipality"
                  label={LOCALE.municipality}
                  fullWidth={true}
                  value={
                    data?.municipality?.name ? data?.municipality?.name : ""
                  }
                  margin="normal"
                  variant="outlined"
                  InputProps={{
                    readOnly: true,
                  }}
                  size="small"
                />
                <TextField
                  id="owned"
                  label={LOCALE.owned_by}
                  fullWidth={true}
                  value={
                    data?.owned === "MUNICIPALITY"
                      ? `${LOCALE.municipality_school}`
                      : data?.owned === "COUNTRY"
                      ? `${LOCALE.country_school}`
                      : ""
                  }
                  margin="normal"
                  variant="outlined"
                  InputProps={{
                    readOnly: true,
                  }}
                  size="small"
                />
                <TextField
                  id="type"
                  label={LOCALE.school_type}
                  fullWidth={true}
                  value={
                    data?.type === "ELEMENTARY_SCHOOL"
                      ? `${LOCALE.elementary_school}`
                      : data?.type === "MIDDLE_SCHOOL"
                      ? `${LOCALE.middle_school}`
                      : ""
                  }
                  margin="normal"
                  variant="outlined"
                  InputProps={{
                    readOnly: true,
                  }}
                  size="small"
                />
                <EntityMetadata data={data} />
              </DialogContent>
              <DialogActions>
                <Link
                  to={`/app/configuration/schools/`}
                  style={{ textDecoration: "none" }}
                >
                  <Button size="small" variant="outlined" color="secondary">
                    {LOCALE.close}
                  </Button>
                </Link>
              </DialogActions>
            </div>
          </CardBody>
        </Dialog>
      </Card>
    </div>
  );
}
